import { normalizePath } from './seoPages';

// Adopt only the server tags this statistics view manages. Helmet can then
// update them in place instead of appending a second canonical/schema graph.
// This also handles a host serving the root document as an SPA fallback.
export function prepareStatsMetadata(page, doc) {
  doc.head.querySelectorAll(
    'meta[name="description"], link[rel="canonical"], link[rel="alternate"], script[type="application/ld+json"]'
  ).forEach((node) => node.setAttribute('data-react-helmet', 'true'));

  try {
    const payload = JSON.parse(doc.getElementById('cd-seo-page-data')?.textContent || '{}');
    if (normalizePath(payload.path) === normalizePath(page.path) && payload.seoLastmod) {
      return { ...page, seoLastmod: payload.seoLastmod };
    }
  } catch {}
  return page;
}